var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02055 4.64677C0.825284 4.45151 0.508701 4.45151 0.313439 4.64677C0.118177 4.84203 0.118177 5.15862 0.313439 5.35388L3.31344 8.35388C3.5087 8.54914 3.82528 8.54914 4.02055 8.35388L11.3539 1.02055C11.5491 0.825284 11.5491 0.508701 11.3539 0.313439C11.1586 0.118177 10.842 0.118177 10.6468 0.313439L3.66699 7.29322L1.02055 4.64677Z",
    fill: "#166DD7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckShape);
export default __webpack_public_path__ + "static/media/icon-check-shape.fbf074040826a2051a9f2500fc491239.svg";
export { ForwardRef as ReactComponent };